import { render, staticRenderFns } from "./goodsgroup.vue?vue&type=template&id=0c04e992&scoped=true&"
import script from "./goodsgroup.vue?vue&type=script&lang=js&"
export * from "./goodsgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c04e992",
  null
  
)

export default component.exports